'use strict';

function reverseString(str) {
  return str.split('').reverse().join('');
}

module.exports = reverseString;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/string/internal/reverseString.js
// module id = 322
// module chunks = 0